module.exports = __webpack_public_path__ + "img/example4.96188fb.png";